import axios from "axios";
import ResponseAlerts from "../functions/ResponseAlerts";

class AggregatesService {
	static async listMonitoringCards(condominiumId) {
		try {
			return await axios.get(
				"/aggregates/automation-buttons/access-points/events/condominiums/" +
				condominiumId,
			);
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: "Erro ao listar logs",
			});
			return error.response;
		}
	}
	static async listEventsWithUsers(unitId, page, filters, orderBy, rowsPerPage, cancelToken) {
		try {
			return await axios.get(
				`/aggregates/units/${unitId}/events/users/paginated?page=${page}` +
				`&idCondominio=${unitId}` +
				`&name=${filters.name}` +
				`&type=${filters.eventType}` +
				`&listMode=${filters.listMode ?? "all"}` +
				`&startDate=${filters.startDate}` +
				`&endDate=${filters.endDate}` +
				`&licence=${filters.licence}` +
				`&detail=${filters.detail}` +
				`&data=${filters.data}` +
				`&user=${filters.user}` +
				`&uuid=${filters.uuid}` +
				`&result=${filters.result}` +
				`&info=${filters.info}` +
				`&carName=${filters.carName}` +
				`&carBrand=${filters.carBrand}` +
				`&carColor=${filters.carColor}` +
				`&carPlate=${filters.carPlate}` +
				`${filters.targetNotEmpty != null ? `&targetNotEmpty=${filters.targetNotEmpty}` : ''}` +
				`&orderBy=${orderBy.collumnTitle}` +
				`&orderDirection=${orderBy.orderDirection}` +
				`&rowsPerPage=${rowsPerPage}`,
				{
					signal: cancelToken
				}
			);
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: "Erro ao listar eventos",
			});
			return error.response;
		}
	}
}

export default AggregatesService;
